<header class="header">
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="image-container">
      <div style="padding-left: 30px">
        <a class="navbar-brand text-white">
          <img src="../../../assets/img/hropal_new.png" alt="hropal-logo" class="logo" />
        </a>
      </div>
    </div>

    <div class="clientLogo">
      <a class="navbar-brand text-white">
        <!-- <img [src]="userLogo" (error)="reloadLogo()" alt="" *ngIf="userLogo" class="user-logo" /> -->
        <img [src]="userLogo" (error)="reloadLogo()" alt=""
          *ngIf="userLogo && logoReloadAttempts < maxLogoReloadAttempts" class="user-logo" />
        <img src="../../../assets/img/HROPAL.png" alt="fallback" *ngIf="logoReloadAttempts >= maxLogoReloadAttempts"
          class="user-logo" />
      </a>
    </div>
    <button class="text-white navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
      aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav me-auto">
        <li class="nav-item"></li>
      </ul>

      <!-- <span>{{ companyName }}</span> -->
      <!-- <div class="dropdown" (click)="enableContent()">
        <button class="dropdown-button">
          Select Company <i class="fa fa-angle-down"></i>
        </button>
        <div class="dropdown-content" *ngIf="displayContent">
          <table class="responsive">
            <thead>
              <th>Company Name</th>
              <th>Short Name</th>
            </thead>
            <tbody>
              <tr *ngFor="let data of datas" (click)="selectItem(data)">
                <td>{{ data.company_name }}</td>
                <td>{{ data.short_name }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div> -->

      <div class="company-selector-wrapper" ngbTooltip="Double click to copy" placement="bottom">
        <ng-select #companySelect *ngIf="datas && datas.length > 0" [items]="datas" bindLabel="company_name"
          bindValue="id" placeholder="Select Company" [(ngModel)]="selectedCompanyId" [searchable]="true"
          class="company-selector" [clearable]="false" (change)="selectItem($event)"
          (dblclick)="copyCompanyName($event)">
          <ng-template ng-option-tmp let-item="item">
            <div class="d-flex justify-content-between">
              <span>{{ item.company_name }}</span>
              <small class="text-muted">{{ item.short_name }}</small>
            </div>
          </ng-template>
        </ng-select>
      </div>

      <div class="d-flex align-items-center mx-4 py-1 px-2 border bg-white rounded">
        <i class="fas fa-solid fa-globe me-2 text-black"></i>
        <select [value]="language" (change)="changeLanguage($event)" class="form-select shadow-none w-auto pad-y1 f14x"
          style="border: none; outline: none">
          <option value="en">English</option>
          <option value="ar">Arabic</option>
          <option value="fr">French</option>
          <option value="de">German</option>
          <option value="ja">Japanese</option>
          <option value="ms">Malay</option>
          <option value="id">Indonesia</option>
        </select>
      </div>

      <!-- <div class="lng-dropdown d-flex px-4" (click)="toggleLanguage()">
        <i class="fas fa-solid fa-globe"></i>
        <div class="dropdown-content" *ngIf="languageDropdown">
          <table>
            <tr (click)="switchLanguage('en')">
              <td>English</td>
            </tr>
            <tr (click)="switchLanguage('ar')">
              <td>Arabic</td>
            </tr>
            <tr (click)="switchLanguage('french')">
              <td>French</td>
            </tr>
            <tr (click)="switchLanguage('german')">
              <td>German</td>
            </tr>
            <tr (click)="switchLanguage('japanese')">
              <td>Japanese</td>
            </tr>
            <tr (click)="switchLanguage('malay mly')">
              <td>Malay</td>
            </tr>
            <tr (click)="switchLanguage('bahasa_indonesia')">
              <td>Indonesia</td>
            </tr>
          </table>
        </div>
      </div> -->

      <!-- Full & Off screen wondow -->
      <div #fullscreenContainer class="fullscreen-container">
        <i class="fa-solid" [ngClass]="fullscreenWindow ? 'fa-compress' : 'fa-expand'" (click)="toggleFullscreen()">
        </i>
      </div>

      <div class="notification-wrapper" #notificationWrapper>
        <!-- <div class="d-flex px-4"> -->
        <div class="notification-icon mx-4" (click)="toggleNotification()">
          <i class="fas fa-bell"></i>
          <span class="notification-count" *ngIf="unreadCount > 0">{{
            unreadCount > 9 ? "9+" : unreadCount
            }}</span>
          <!-- <img *ngIf="isPanelOpen" src="assets/img/arrow.svg" class="notification-arrow" alt="arrow" /> -->
          <svg *ngIf="isPanelOpen" class="notification-arrow" width="24" height="14" viewBox="0 0 24 14"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M12 0 L24 14 H0 Z" fill="red" />
          </svg>
        </div>


        <div class="notification-panel" *ngIf="isPanelOpen">
          <!-- Header -->
          <div class="panel-header">
            <h5 class="panel-title m-0">Notifications</h5>
            <div class="panel-actions">
              <a (click)="markasReadAll()" *ngIf="notifications?.length">Mark all as read</a>
              <a (click)="clearAll()" *ngIf="notifications?.length">Clear all</a>
              <span class="close-icon" (click)="closePanel()">×</span>
            </div>
          </div>

          <!-- List -->
          <ul class="notification-list">
            <li class="m-0" *ngFor="let msg of notifications">
              <div class="notification-item" [ngClass]="{ 'unread': !msg.isRead, 'read': msg.isRead }">
                <!-- Avatar -->
                <div class="avatar">
                  <i class="fa fa-user"></i>
                </div>

                <!-- Content -->
                <div class="notification-content" (click)="markasRead(msg, 'url')">
                  <p class="notification-text">
                    <strong>{{ msg.title }}</strong>
                  </p>

                  <p *ngIf="msg?.moduleType == 'Bulk Upload'" class="notification-sub" [ngClass]="{
                    'text-danger': msg?.message?.toLowerCase().includes('fail'),
                    'text-success': msg?.message?.toLowerCase().includes('success')
                    }">
                    {{ msg.message }}
                    <a *ngIf="msg?.actionUrl" class="ms-1 text-primary" title="Download error report"
                      (click)="$event.stopPropagation(); downloadNotificationFile(msg.actionUrl)">
                      <i class="fa fa-download"></i> Download Report
                    </a>
                  </p>

                  <p class="notification-sub" *ngIf="msg?.moduleType == 'PAYROLL'">
                    <!-- Payroll complete: -->
                    <span *ngIf="msg.processedPart">Payroll complete: <span class="text-success">{{ msg.processedPart
                        }},</span>
                    </span>
                    <span class="text-danger" *ngIf="msg.failedPart">{{ msg.failedPart }}</span>
                  </p>

                  <p class="notification-sub" *ngIf="msg?.moduleType != 'PAYROLL' && msg?.moduleType != 'Bulk Upload'">
                    {{ msg.message }}
                  </p>

                  <div class="notification-time">
                    <i class="fa fa-calendar"></i>
                    {{ msg.createdAt | customDate: (angularDateFormat || dateFormat) + ' hh:mm a' }}
                  </div>
                </div>

                <!-- Actions -->
                <div class="notification-actions">
                  <i *ngIf="!msg.isRead" class="fa fa-check" title="Mark as read" (click)="markasRead(msg, 'id')"></i>

                  <!-- <i *ngIf="msg.actionUrl" class="fa fa-eye" title="View"></i> -->
                </div>
              </div>
            </li>
          </ul>

          <!-- View All Footer -->
          <div class="panel-footer">
            <a routerLink="/app/master/notification-report" (click)="closePanel()">
              <i class="fas fa-list"></i> View All Notifications
            </a>
          </div>
        </div>
      </div>

      <div class="user-profile d-flex align-items-center" (click)="toggleDropdown()">
        <img [src]="userProfile || 'assets/img/userLogo.png'" alt="User Profile" class="rounded-circle" width="30" />
        <span class="ms-2">{{ loggedUser?.name }}</span>
      </div>

      <div class="d-flex px-3 logout-section">
        <i [class]="isDropdownOpen ? 'fas fa-angle-up' : 'fas fa-angle-down'" (click)="toggleDropdown()"></i>
        <div class="dropdown d-flex">
          <div [class]="dropdownClass" (mouseleave)="toggleDropdown()">
            <button *ngIf="employeeName?.role == 3 || employeeName?.role == 4" class="dropdown-item"
              [routerLink]="['/app/employee/list/profile-info', employeeName?.userID]" (click)="toggleDropdown()">
              <i class="fa fa-user" aria-hidden="true"></i> <span>Profile</span>
            </button>
            <button class="dropdown-item" (click)="toggleDropdown(); onChangePasswordClick()"
              routerLinkActive="router-link-active">
              <i class="fa-solid fa-key" aria-hidden="true"></i>
              <span>Change Password</span>
            </button>
            <button class="dropdown-item" (click)="logout()" (click)="toggleDropdown()">
              <i class="fa fa-sign-out" aria-hidden="true"></i>
              <span>Log out</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </nav>
</header>